import React from 'react';
import './FilterDisplay.css';
import { buildApiUrl } from '../../config/api.config';

const FilterDisplay = ({ category, food_list }) => {
  // Check if food_list exists and has items before mapping
  if (!food_list || food_list.length === 0) {
    return null;
  }

  // Filter items based on category
  const filteredItems = food_list.filter(item => category === "All" || category === item.category);

  // Select the last 2 items
  const lastTwoItems = filteredItems.slice(-2);

  return (
    <section className="filter-wrapper-main">
      <div className="filter-container">
        <div className="filter-grid">
            {lastTwoItems.map((item, index) => (
             <div key={index} className="filter-card">
              <div className="filter-image-container">
                <img 
                  src={buildApiUrl(`/uploads/${item.image}`)} 
                  alt={item.name} 
                  className="filter-image"
                />
               </div>
               <div className="filter-content">
                 <div className="filter-category">{item.category}</div>
                 <h3 className="filter-name">{item.name}</h3>
                 <p className="filter-description">
                   {item.description}
                 </p>
                 <a href="#" className="filter-btn">Read Article &rarr;</a>
               </div>
             </div>
            ))}
        </div>
      </div>
    </section>
  );
}

export default FilterDisplay;
